/**
 * Состояние звонка этой вкладки для экранов (изменение v1.14).
 *
 * `view` — снимок сессии (фаза, mute, эмодзи, итог), `minimized` — звонок свёрнут в полосу,
 * `notice` — объяснение, почему звонок не состоялся (микрофон, запрет, браузер).
 */
import { create } from 'zustand'

import type { CallView } from './session'

export interface CallNotice {
  title: string
  text: string
}

interface CallState {
  view: CallView | null
  minimized: boolean
  notice: CallNotice | null
  /** Вызов, который вкладка сейчас принимает: входящий экран уступает место экрану звонка. */
  acceptingId: string | null
  setView: (view: CallView | null) => void
  setMinimized: (minimized: boolean) => void
  setNotice: (notice: CallNotice | null) => void
  setAccepting: (callId: string | null) => void
}

export const useCallStore = create<CallState>((set) => ({
  view: null,
  minimized: false,
  notice: null,
  acceptingId: null,
  setView: (view) => set(view ? { view } : { view: null, minimized: false }),
  setMinimized: (minimized) => set({ minimized }),
  setNotice: (notice) => set({ notice }),
  setAccepting: (acceptingId) => set({ acceptingId }),
}))
